import React from "react";
import { SiNike, SiNetflix, SiGoogle } from "react-icons/si";
import { FaAmazon } from "react-icons/fa";

const MOIMOI_URL =
  "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/ec89v8ez_IMG_9522.WEBP";

const items = [
  { type: "icon", Icon: SiNike, label: "Nike" },
  { type: "word", label: "Cartier", word: "CARTIER" },
  { type: "icon", Icon: SiNetflix, label: "Netflix" },
  { type: "icon", Icon: FaAmazon, label: "Amazon" },
  { type: "icon", Icon: SiGoogle, label: "Google" },
  { type: "img", label: "Moi Moi Sauce", src: MOIMOI_URL },
];

const LogoCell = ({ type, Icon, label, word, src }) => (
  <div
    className="flex items-center justify-center px-10 py-2 min-w-[160px]"
    data-testid={`logo-strip-${label.toLowerCase().replace(/\s+/g, "-")}`}
    title={label}
  >
    {type === "icon" && (
      <Icon size={36} color="#594838" style={{ opacity: 0.7 }} aria-label={label} />
    )}
    {type === "word" && (
      <span
        className="font-display tracking-[0.28em] text-[var(--lt-bark)]/70 whitespace-nowrap"
        style={{ fontSize: "1.05rem", fontWeight: 600 }}
      >
        {word}
      </span>
    )}
    {type === "img" && (
      <img
        src={src}
        alt={label}
        className="h-12 w-auto select-none"
        style={{ mixBlendMode: "screen", opacity: 0.95 }}
        draggable={false}
      />
    )}
  </div>
);

const LogoStrip = () => {
  const row = [...items, ...items];
  return (
    <section
      data-testid="logo-strip-section"
      className="py-16 lg:py-20 border-t border-b border-[var(--lt-line)] bg-[var(--lt-cream)]/40"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <p className="eyebrow text-center mb-10" data-testid="logo-strip-eyebrow">
          Our founders have previously worked with
        </p>
        <div className="overflow-hidden relative">
          <div className="flex items-center lt-marquee" style={{ width: "fit-content" }}>
            {row.map((it, i) => (
              <LogoCell key={`${it.label}-${i}`} {...it} />
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--lt-peace)] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--lt-peace)] to-transparent" />
        </div>
        <p className="mt-8 text-center text-xs text-[var(--lt-bark)]/60 font-body tracking-[0.06em]">
          Brand work through prior roles and current studio engagements.
        </p>
      </div>
    </section>
  );
};

export default LogoStrip;
